export const messages = {
  compatOrgsFailed: 'Could not load your organizations, so the endpoint list could not be read. This is a failed read — it does not mean no endpoints are configured.',
  compatRetry: 'Try again',
  compatNoOrgs: 'No organization yet — create one to add a self-hosted endpoint.',
  rtGeminiAssurance: 'Gemini Live locks your persona and tools server-side, but tool execution and transcripts are relayed by the browser — lower assurance, not recommended for governance or audit tenants. OpenAI Realtime keeps these host-side.',
  // ADR 0141 real-time voice settings
  rtTitle: "Real-time voice",
  rtDesc: "Use a real-time speech-to-speech provider for live voice conversations. Falls back to recorded voice when off.",
  rtProvider: "Provider",
  rtProviderOff: "Off (recorded voice)",
  rtKey: "API key",
  rtKeySelect: "Select a stored key…",
  rtKeysUnreadable: "Couldn’t load your stored keys, so this card can’t tell whether the configured key still exists. Nothing here is a verdict on your setup — reload to check.",
  rtNoKeys: "Add a key above first.",
  rtKeyMissing: "{{ref}} — missing",
  rtKeyMissingWarning: "This workspace is set to use the key \"{{ref}}\", but that key no longer exists. Real-time voice will fail to start until you pick a key that is still stored.",
  rtSave: "Save",
  rtSaving: "Saving…",
  rtSaved: "Real-time voice settings saved.",
  rtLoadFailed: "The current real-time voice settings could not be loaded, so they cannot be changed here right now.",
  rtRetry: "Try again",

  // Default AI provider for media (ADR 0110)
  aiDefaultTitle: 'Default AI provider for media',
  aiDefaultIntro: 'Image OCR and audio transcription need a multimodal model. The free managed model is text-only, so pick one of your own provider keys + a capable model to use for media.',
  aiDefaultNoKeys: 'Add a provider API key above first — then you can choose it as the default for media.',
  aiDefaultProvider: 'Provider',
  aiDefaultProviderHelp: 'Google (Gemini) handles images and audio. Anthropic and OpenAI handle images only.',
  aiDefaultAudioWarn: 'Audio transcription needs Google (Gemini). With Anthropic or OpenAI, only images will be processed.',
  aiDefaultModel: 'Model',
  aiDefaultModelHelp: 'A vision/audio-capable model id, e.g. gemini-2.0-flash, claude-sonnet-4, or gpt-4o.',
  aiDefaultKey: 'API key to use',
  aiDefaultKeyHelp: 'One of your stored provider keys above. The key value stays on the host.',
  aiDefaultPreferText: "Use this key for background AI",
  aiDefaultPreferTextHelp: "When on, these background text tasks run on this key and are billed to your provider account instead of the workspace’s included AI allowance: content translation and rewriting, evaluation judging, chat auto-titles (on the provider’s smaller, faster model) and memory extraction. If the key is deleted or expires, they go back to the included allowance. Off by default; takes effect when you save.",
  aiDefaultKeyPlaceholder: 'Select a stored key…',
  aiDefaultSave: 'Save default',
  aiDefaultClear: 'Clear',
  aiDefaultSaved: 'Default AI provider saved.',
  aiDefaultCleared: 'Default AI provider cleared.',
  aiDefaultError: 'Could not save the default AI provider.',
  provider_google: 'Google (Gemini)',
  provider_anthropic: 'Anthropic (Claude)',
  provider_openai: 'OpenAI',

  // Stepper
  stepProvider: 'Provider',
  stepModel: 'Model',
  stepKey: 'API key',

  // Wizard divider
  orDivider: 'or',
  orDividerText: 'OR',

  // ConfiguredProviderCard
  deleteKeyConfirm: 'Delete BYOK key for {{provider}}?',
  changeProviderModel: 'Change provider / model',
  changeAction: 'change',
  serverManagedLimit: 'Server-managed · daily usage limit applies',
  modelKeyLabel: '{{model}} · key',
  change: 'Change',
  disconnect: 'Disconnect',
  deleteKeyLabel: 'Delete key',
  disconnectAction: 'Disconnect',
  stopUsingAction: 'Stop using',
  stopUsingLabel: 'Stop using {{provider}} for this chat',
  subscriptionModelLabel: '{{model}} · connected through GitHub',
  deleteAction: 'Delete',

  // KeyEntry
  prefixWarning: 'Anthropic keys usually start with "{{prefix}}". Continuing anyway.',
  addYourKeyTitle: 'Add your {{provider}} API key',
  usingModel: 'Using',
  getAKey: 'Get a key →',
  payProviderDirectly: 'You pay {{provider}} directly for usage.',
  apiKeyLabel: 'API key',
  hideKey: 'Hide key',
  showKey: 'Show key',
  hide: 'Hide',
  show: 'Show',
  storing: 'Storing…',
  storeKey: 'Store key',
  back: 'Back',
  // ADR 0517 open question 1 — duplicate keys per provider are inert but invisible.
  duplicateKeysWithActive_one: 'Your chat is using {{active}}. The other one stored here is inactive — removing it is safe.',
  duplicateKeysWithActive_other: 'Your chat is using {{active}}. The other {{count}} stored here are inactive — removing them is safe.',
  duplicateKeysNoneActive: '{{count}} {{provider}} keys are stored, and your chat is not bound to any of them. Pick one in the chat, or remove the ones you no longer need.',
  duplicateKeysUnknownActive: '{{count}} {{provider}} keys are stored. We could not read which one your chat is using, so check there before removing any.',
  // ADR 0517 fix A — reuse an existing stored key instead of asking again.
  savedKeyFound: 'You already have a {{provider}} key saved',
  savedKeyExplain: 'It is stored on the server for this workspace. Reconnect it — no need to paste it again.',
  savedKeyUse: 'Use my saved key',
  savedKeyUsing: 'Connecting…',
  savedKeyReplaceHint: 'Only enter a key below if you want to REPLACE the saved one.',
  replaceKey: 'Replace key',
  // ADR 0517 fix D — a lapsed session is not a missing key.
  sessionExpiredTitle: 'Your session ended',
  sessionExpiredBody: 'Sign back in to reconnect this workspace. Your API key is still saved on the server — you do not need to enter it again.',
  sessionExpiredSignIn: 'Sign back in',
  sessionExpiredSigningIn: 'Signing in…',
  sessionExpiredUseKey: 'Set up a key instead',

  // ModelGrid
  modelIdRequired: 'Model id is required.',
  pickAModel: 'Pick a model',
  fromProvider: 'From',
  recommended: 'recommended',
  contextWindowSuffix: '{{n}}K ctx',
  costPerMillion: '${{input}}/1M in · ${{output}}/1M out',
  otherModel: 'Other…',
  enterModelIdManually: 'enter model id manually',
  otherModelDesc: 'For preview releases, fine-tunes, snapshots, or any model not in the list above.',
  customModel: 'Custom model',
  customModelIdLabel: 'Model id (as the provider expects it)',
  customModelPlaceholderDefault: 'provider-model-id',
  customModelHelpDefault: "Whatever model id {{provider}}'s API accepts.",
  useThisModel: 'Use this model',
  cancel: 'Cancel',

  // ProviderGrid / TryItFreeCard
  tryItFreeTitle: 'Try it free',
  tryItFreeSuffix: 'by creating an account',
  tryItFreeDesc: 'No API key needed. Sign in and start chatting — the server uses a host-managed key with reasonable per-account limits.',
  tryItFreeHint: '{{hint}} →',
  byokTitle: 'Bring your own key (BYOK)',
  byokAbbrTitle: 'Bring Your Own Key',
  byokLedeBefore: 'means you supply the API key for the model provider you pick below. The provider bills you directly for your usage; OpenWOP doesn\'t bill you or take a cut. The server forwards each request to the provider using your key, then streams the response back.',
  byokFineprintTrust: 'Your key is stored on the server (encrypted at rest with AES-256-GCM) and sent only to the provider you picked.',
  byokFineprintOperatorEyebrow: 'For operators',
  byokFineprintBefore: 'Set',
  byokFineprintMid: 'on the server to switch to in-memory-only mode that wipes on restart. Production hosts swap this storage for a managed key-management service (KMS) like AWS KMS, GCP KMS, or HashiCorp Vault — see',
  byokFineprintAfter: 'for the adapter pattern.',
  settingsEyebrow: 'Settings',
  apiKeysTitle: 'API keys',
  apiKeysLede: 'Manage the API keys your workflows use. Each key is stored server-side (encrypted at rest); the chat and workflow-node dispatchers reference a key by its label. Add multiple keys per provider (e.g., separate prod/test keys) and pick which one a specific workflow node uses from the builder.',
  refresh: 'Refresh',
  storedKeysByProvider: 'Stored keys by provider',
  totalKeys: 'Total keys',
  keysViewTable: 'Table',
  unscoped: 'Unscoped',
  noKeysTitle: 'No API keys yet',
  noKeysBody: 'Add a key to let chat and workflow nodes call a provider on your behalf. Keys are encrypted at rest; nodes reference them by label.',
  keyCount_one: '{{count}} key',
  keyCount_other: '{{count}} keys',
  addProviderKey: 'Add {{provider}} key',
  addKey: 'Add key',
  storedProviderKeys: 'Stored {{provider}} keys',
  noProviderKeysTitle: 'No {{provider}} keys yet',
  noProviderKeysBody: 'Add a key to let chat and workflow nodes call this provider.',
  addAKey: 'Add a key',
  referenceColumn: 'Reference',
  maskedValueColumn: 'Masked value',
  maskedRenderingTitle: 'Masked rendering returned by the BE on store',
  deleteRefLabel: 'Delete {{ref}}',
  unscopedKeysChip: 'Unscoped keys',
  unscopedKeysNoticeBefore: 'These credentials don’t carry a',
  unscopedKeysNoticeAfter: 'prefix. They still work, but the per-node picker can’t filter them by provider. Delete and re-add to scope them.',
  unscopedKeysCaption: 'Unscoped keys',
  deleteKeyModalLabel: 'Delete key',
  deleteThisKeyTitle: 'Delete this key?',
  deleteThisKeyBodyBefore: 'Nodes referencing',
  deleteThisKeyBodyAfter: 'will fail until you re-add a key with the same label. This can’t be undone.',
  deleting: 'Deleting…',

  // AddKeyForm
  labelRequired: 'Label is required.',
  keyValueRequired: 'Key value is required.',
  labelTakenError: 'A key with this label already exists. Pick a different label.',
  addKeyPrefixWarning: '{{provider}} keys usually start with `{{prefix}}`. Double-check this is the right provider.',
  addKeyLooksLikeOther: 'This looks like a {{other}} key (it starts with `{{prefix}}`). A key saved under the wrong card fails when a run uses it.',
  addKeySwitchTo: 'Add it under {{other}}',
  addKeyKeepHere: 'Keep it under {{provider}}',
  addKeyChooseCard: 'This key looks like a {{other}} key. Add it under {{other}}, or choose to keep it under {{provider}}.',
  labelFieldLabel: 'Label',
  labelFieldHint: '(used to identify the key in workflow nodes)',
  labelPlaceholder: 'prod, test, personal, …',
  willBeStoredAs: 'Will be stored as',
  keyPlaceholderDefault: 'API key',
  getKeyFromProvider: 'Get a key from {{provider}}',
  saving: 'Saving…',
  saveKey: 'Save key',

  // Web search key (ADR 0101 Phase 3)
  searchAnswerOnly: 'Search: chat only',
  searchAnswerOnlyHint: 'This provider’s built-in web search can ground chat answers, but its results can’t be saved as citations — features that store evidence (like the Challenge Factory) need a web-search key below.',
  webSearch: {
    title: 'Web search',
    configured: 'Key configured',
    body: "Optional. A search-provider key lets agents search the web, and it is what makes features that SAVE sources as evidence (the Challenge Factory today) work at all. Exa, Brave and Tavily are supported — paste any of their keys and we detect which. Exa's free credit covers about 2,800 searches. Providers that ground natively (e.g. Gemini) use your own model key for chat answers, but their results can't be saved as citations.",
    keyLabel: 'Search-provider API key',
    placeholder: 'Search-provider API key',
  },

  // Self-hosted / OpenAI-compatible endpoints (RFC 0108 / ADR 0121)
  compatTitle: 'Self-hosted / OpenAI-compatible endpoints',
  compatLoading: 'Loading endpoints…',
  compatIntro: 'Connect Ollama, LM Studio, vLLM, or any OpenAI-compatible API by base URL (with an optional key). Declare what the endpoint supports — the host can’t probe a private endpoint, so capabilities are taken from what you set here.',
  compatOrg: 'Organization',
  compatHasKey: 'key set',
  compatVision: 'vision',
  compatTools: 'tools',
  compatLongContext: 'long context',
  compatDelete: 'Remove',
  compatDeleteConfirm: 'Remove this endpoint?',
  compatLabel: 'Label',
  compatBaseUrl: 'Base URL',
  compatBaseUrlHelp: 'The OpenAI-compatible base, e.g. http://localhost:11434/v1 (https required unless a local endpoint is explicitly allowed).',
  compatApiKey: 'API key (optional)',
  compatApiKeyHelp: 'Left empty for keyless local endpoints (e.g. Ollama). The value stays on the host.',
  compatCapsLegend: 'Declared capabilities',
  compatModels: 'Model ids (optional, comma-separated)',
  compatModelsList: 'Models: {{list}}',
  compatAdd: 'Add endpoint',
  compatSaved: 'Endpoint added',
  compatError: 'Could not save the endpoint.',
  compatReadOnly: 'You have read-only access to this organization’s endpoints.',

  // RFC 0121 AT-OWN-RISK subscription credential (ADR 0180)
  sub: {
    title: 'Personal subscription (at your own risk)',
    intro: 'Reuse a personal, non-metered consumer subscription (e.g. ChatGPT Plus) as a provider credential instead of a metered API key. Only available because this host has been configured to allow it.',
    riskDisclosure: 'Reusing your personal subscription may violate the provider’s terms of service and risk account suspension. This is your own risk to accept — the credential is bound only to your user account and never shared with your team.',
    providerLabel: 'Provider',
    valueLabel: 'Subscription credential',
    valuePlaceholder: 'Subscription credential',
    valueHelp: 'The value stays on the host and is dispatched only to the operator-configured endpoint.',
    acknowledge: 'I understand reusing my personal subscription may violate the provider’s terms of service and risk account suspension.',
    save: 'Bind subscription',
    saved: 'Subscription credential bound to your user account.',
    boundTitle: 'Bound credential',
  },
  copilot: {
    pickerTitle: 'Your subscriptions',
    pickerDesc: 'Chat through your connected GitHub Copilot plan.',
    title: 'GitHub Copilot',
    intro: 'Use your own GitHub Copilot plan for chat in your personal workspace. Each request counts toward your Copilot allowance.',
    scopeNote: 'GitHub asks you to authorize this app. It requests no permission scopes, so it cannot read your repositories or private data.',
    connect: 'Connect GitHub Copilot',
    disconnect: 'Disconnect',
    connected: 'GitHub Copilot is connected to your account.',
    disconnected: 'GitHub Copilot is disconnected.',
    error: 'GitHub Copilot could not be connected. Try again, and make sure you are signed in to the same account.',
    personalOnly: 'Available in your personal workspace only.',
  },
  getProviderKey: 'Get a {{provider}} API key →',
  // ADR 0779 D7 — write authority + honest delete refusals
  readOnlyNotice: "Only workspace admins can add or remove AI keys here. You can still use the keys this workspace already has.",
  deleteBlockedReferences: "This key is still in use, so it was not deleted. It is used by:",
  deleteBlockedUnknown: "We couldn’t check what uses this key, so it was not deleted.",
  deleteBlockedOwner: "This key is managed by {{owner}}. Remove it there instead.",
  deleteAnyway: "Delete anyway",
  deleteAnywayHint: "Deleting anyway breaks anything that still uses this key. The override is recorded in the audit log.",
  aiDefaultReadOnly: "Only workspace admins can change the default AI provider.",
  aiDefaultLoadFailed: "We couldn’t load the current default, so this card can’t show it. Nothing has changed.",
  compatAdminOnly: "Only workspace admins can add or remove self-hosted endpoints.",
  compatRemoveLabel: "Remove endpoint {{label}}",
  webSearchRemoveTitle: "Remove the web search key?",
  webSearchRemoveBody: "Agents lose web search, and features that save sources as evidence stop working until you add a key again.",
} as const;
